export default "__VITE_ASSET__CP1DgWZr__"